//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/Object.js";
import "../no/BasePart.js";
import "../Features/Features.FeatureCollection.js";
let d=[[],[[["morph_mesh"],"CreateMorphMeshBuilder",{R_:{builder:"Features.MorphMeshBuilder"}},1,0],[[],"CreateMorphMeshCageBuilder",{R_:{builder:"Features.MorphMeshCageBuilder"}},0,0],[[],"CreateMorphMeshSymmetricCageBuilder",{R_:{builder:"Features.MorphMeshSymmetricCageBuilder"}},0,0],[[],"CreateMorphMeshTransformBuilder",{R_:{data:"Features.MorphMeshTransformBuilder"}},0,0],[[],"CreateMorphMeshTwistBendData",{R_:{data:"Features.MorphMeshTwistBendData"}},0,0],[[],"CreateMorphMeshConstraintBuilder",{R_:{data:"Features.MorphMeshConstraintBuilder"}},0,0],[[],"CreateMorphMeshDeleteConstraintBuilder",{R_:{data:"Features.MorphMeshDeleteConstraintBuilder"}},0,0],[[],"StopSymmetricModeling",{},0,0]],[]];
SPLM.Features.MorphMeshCollection = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Features.MorphMeshCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;